// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"fb87aa3c","833":"82ebd942"}[chunkId] + ".chunk.js";
};